import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import QDatepicker from '_Components/Fields/QDatepicker/QDatepicker';
import { Label } from '_Cards/FilterCards/DataByFiltersCard/_Containers/Dropdowns/utils/DropdownStyles';
import QBooleanSwitch from '_Components/Fields/QBooleanSwitch/QBooleanSwitch';
import { grayShades } from 'styles/abstracts/colors';
import { get } from 'lodash';
import ThematicSelectionDropdown from '_Cards/ThematicsCard/ThematicsOverviewCards/CategoryBreakdownCard/_Containers/DropdownsContainer/_Components/ThematicSelectionDropdown';
import { MAIN_INDICATOR_CONFIG, EXPLAIN_INDICATOR_CONFIG, ORDER_BY_CONFIG } from './utils';
import VarianceDropdown from './_Containers/VarianceDropdown';
import VarianceOrderByDropdown from './_Containers/VarianceOrderByDropdown';

const SelectsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 0 3.5em;
  margin-right: 1em;
  flex-wrap: wrap;
`;

const IndicatorsDropdownsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: 2em;
  margin-left: 3em;
  & div {
    margin-right: 0.5em;
  }
`;

type ThematicSelectionType = {
  createdBy: {
    firstName: string;
    lastName: string;
    email: string;
  };
  id: number;
  label: string;
  name: string;
  projectId: number;
  thematics: Array<{
    thematic: string;
    subThematic: string | null;
    subSubThematic: string | null;
  }>;
};

type DropdownsContainerProps = {
  setExplainIndicator: Function;
  setMainIndicator: Function;
  setReferencePeriod: Function;
  mainIndicator: string;
  explainIndicator: number;
  referencePeriod: { startDate: string; endDate: string };
  projectPeriods: any[];
  details: boolean;
  setDetails: Function;
  setOrderBy: Function;
  orderBy: string;
  t: Function;
  thematicSelection: ThematicSelectionType;
  selectedThematicSelectionOption: ThematicSelectionType;
  onThematicSelectionChange: Function;
  currentThematicSelection: any;
  thematicSelectionsOptions: Array<ThematicSelectionType>;
};

const DropdownsContainer = ({
  setExplainIndicator,
  explainIndicator,
  setMainIndicator,
  mainIndicator,
  setReferencePeriod,
  referencePeriod,
  setDetails,
  details,
  setOrderBy,
  orderBy,
  onThematicSelectionChange,
  currentThematicSelection,
  thematicSelectionsOptions,
  projectPeriods,
  t,
}: DropdownsContainerProps) => {
  return (
    <div>
      <SelectsContainer>
        <div>
          <Label>{t('Reference period')}</Label>
          <QDatepicker
            startDate={referencePeriod?.startDate}
            endDate={referencePeriod?.endDate}
            periods={projectPeriods}
            onPeriodUpdate={setReferencePeriod}
          />
        </div>
        <IndicatorsDropdownsContainer>
          <VarianceDropdown
            callback={setMainIndicator}
            currentSetting={MAIN_INDICATOR_CONFIG.find(i => i.value === mainIndicator)}
            itemToIterate={MAIN_INDICATOR_CONFIG}
            id="mainIndicatorVarianceDropdown"
            label="Main indicator"
          />
          <VarianceDropdown
            callback={setExplainIndicator}
            currentSetting={EXPLAIN_INDICATOR_CONFIG.find(i => i.value === explainIndicator)}
            itemToIterate={EXPLAIN_INDICATOR_CONFIG}
            id="explainIndicatorVarianceDropdown"
            label="Explain indicator"
          />
          <VarianceOrderByDropdown
            label="Sort by"
            id="orderByVarianceDropdown"
            itemToIterate={ORDER_BY_CONFIG}
            callback={setOrderBy}
            currentSetting={ORDER_BY_CONFIG.find(i => i.value === orderBy.split('_')[0]).subcategories.find(
              i => i.value === orderBy,
            )}
          />
          <ThematicSelectionDropdown
            id="thematicSelectionDropdownContainer"
            label="button:Selected categories"
            t={t}
            options={thematicSelectionsOptions}
            thematicSelection={currentThematicSelection}
            setThematicSelection={onThematicSelectionChange}
            benchmark={false}
          />
        </IndicatorsDropdownsContainer>
        <div id="detailsVarianceDropdown">
          <Label>
            {t('Details')} ({t('VolumeTonalityMixEffectsLogos')})
          </Label>
          <QBooleanSwitch value={details} onChanged={() => setDetails(!details)} labelColor={grayShades.g800} />
        </div>
      </SelectsContainer>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  projectPeriods: get(state, ['periods', 'projectPeriods']),
});

export default withTranslation('card', ['button'])(connect(mapStateToProps)(DropdownsContainer));
